import React, { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import {
  Check,
  ArrowRight,
  MessageCircle,
  Crown,
  Sparkles,
  ChevronDown,
} from "lucide-react";
import { Helmet } from "react-helmet";

const COMBOS = [
  {
    id: 1,
    tier: "01",
    tierName: "STANDARD",
    name: "Standard",
    subtitle: "The Classic Moment",
    tagline: "Intimate celebration with private screening, lights, cake & photography.",
    badge: "INTIMATE CLASSIC",
    badgeType: "classic",
    accentColor: "#B38E32",
    themeClass: "theme-standard",
    glowColor: "rgba(201, 168, 76, 0.3)",
    btnGradient: "linear-gradient(135deg, #7A5C16 0%, #B38E32 50%, #D4AF37 100%)",
    isFeatured: false,
    highlightChips: [
      { emoji: "🎂", label: "1/2 Kg Fresh Cake" },
      { emoji: "📸", label: "15 Min Photography" },
      { emoji: "🌫️", label: "Magical Fog Entry" },
      { emoji: "🕯️", label: "Candlelit Walkway" },
    ],
    featuresList: [
      "100% Private Theatre Auditorium (Exclusive)",
      "Ambient Romantic Decor & Fairy Lighting",
      "Magical Fog Entry at Entrance (1 Pot)",
      "Candlelit Walkway & Custom LED Name",
      "Fresh Celebration Cake (1/2 Kg)",
      "Dedicated Photography (15 Mins)",
    ],
    fullFeatures: [
      { name: "Private Theatre & Ambient Decor", included: true },
      { name: "Magical Fog Entry (1 Pot)", included: true },
      { name: "Candlelit Walkway Path", included: true },
      { name: "Happy Birthday LED Feature", included: true },
      { name: "Custom Name with LED (up to 6 letters)", included: true },
      { name: "Age Number LED Display", included: true },
      { name: "HBD Setup with Fresh Rose Petals", included: true },
      { name: "10 Photo Clipping Memories", included: true },
      { name: "Celebration Sash, Crown & Spects", included: true },
      { name: "Single Fresh Red Rose", included: true },
      { name: "Regular Celebration Cake (1/2 kg)", included: true },
      { name: "Dedicated Photography (15 Mins)", included: true },
      { name: "Cold Fire Grand Entry (6 pcs)", included: false },
      { name: "Cinematic Videography (1-Min Reel)", included: false },
      { name: "Atmospheric Hall Fog (4 Pots)", included: false },
    ],
  },
  {
    id: 2,
    tier: "02",
    tierName: "SPECIAL",
    name: "Special",
    subtitle: "The Royal Signature",
    tagline: "Our #1 most booked package. Custom 1 kg theme cake, 30m photos & cold fire entry.",
    badge: "MOST POPULAR ★",
    badgeType: "featured",
    accentColor: "#C9A84C",
    themeClass: "theme-special",
    glowColor: "rgba(201, 168, 76, 0.4)",
    btnGradient: "linear-gradient(135deg, #2D0A31 0%, #5E0E73 55%, #B32671 100%)",
    isFeatured: true,
    highlightChips: [
      { emoji: "🎂", label: "1 Kg Theme Cake" },
      { emoji: "📸", label: "30 Min Photography" },
      { emoji: "🎆", label: "4 Cold Fire Sparks" },
      { emoji: "🌹", label: "6 Fresh Roses Bouquet" },
    ],
    featuresList: [
      "100% Private Theatre Auditorium (Exclusive)",
      "Cold Fire Grand Spark Entry (4 Pcs)",
      "Customised Celebration Theme Cake (1 Kg)",
      "Fresh Red Rose Bouquet (6 Roses)",
      "Candlelit Walkway & Custom LED Name",
      "Dedicated Extended Photography (30 Mins)",
    ],
    fullFeatures: [
      { name: "Private Theatre & Ambient Decor", included: true },
      { name: "Magical Fog Entry (1 Pot)", included: true },
      { name: "Candlelit Walkway Path", included: true },
      { name: "Happy Birthday LED Feature", included: true },
      { name: "Custom Name with LED (up to 6 letters)", included: true },
      { name: "Age Number LED Display", included: true },
      { name: "HBD Setup with Fresh Rose Petals", included: true },
      { name: "10 Photo Clipping Memories", included: true },
      { name: "Celebration Sash, Crown & Spects", included: true },
      { name: "Fresh Rose Bouquet (6 Roses)", included: true },
      { name: "Customised Theme Cake (1 kg)", included: true },
      { name: "Dedicated Photography (30 Mins)", included: true },
      { name: "Cold Fire Grand Entry (4 pcs)", included: true },
      { name: "Cinematic Videography (1-Min Reel)", included: false },
      { name: "Atmospheric Hall Fog (4 Pots)", included: false },
    ],
  },
  {
    id: 3,
    tier: "03",
    tierName: "PREMIUM",
    name: "Premium",
    subtitle: "The Deluxe Grand Affair",
    tagline: "The ultimate VIP celebration. Includes 4K cinematic video reel, 12 roses & hall fog.",
    badge: "DELUXE VIP",
    badgeType: "premium",
    accentColor: "#7A288A",
    themeClass: "theme-premium",
    glowColor: "rgba(147, 51, 234, 0.35)",
    btnGradient: "linear-gradient(135deg, #3B0764 0%, #6B21A8 50%, #9333EA 100%)",
    isFeatured: false,
    highlightChips: [
      { emoji: "🎥", label: "4K Video Reel (1-Min)" },
      { emoji: "🎂", label: "1 Kg Theme Cake" },
      { emoji: "🎆", label: "6 Cold Fire Sparks" },
      { emoji: "👑", label: "12 Roses & Hall Fog" },
    ],
    featuresList: [
      "100% Private Theatre Auditorium (Exclusive)",
      "Cinematic 4K Video Reel (1-Min Edited)",
      "Cold Fire Grand Spark Entry (6 Pcs)",
      "Atmospheric Full Hall Fog (4 Pots)",
      "Luxury Fresh Rose Bouquet (12 Roses)",
      "Dedicated Extended Photography (30 Mins)",
    ],
    fullFeatures: [
      { name: "Private Theatre & Ambient Decor", included: true },
      { name: "Magical Fog Entry (1 Pot)", included: true },
      { name: "Candlelit Walkway Path", included: true },
      { name: "Happy Birthday LED Feature", included: true },
      { name: "Custom Name with LED (up to 6 letters)", included: true },
      { name: "Age Number LED Display", included: true },
      { name: "HBD Setup with Fresh Rose Petals", included: true },
      { name: "10 Photo Clipping Memories", included: true },
      { name: "Celebration Sash, Crown & Spects", included: true },
      { name: "Luxury Rose Bouquet (12 Roses)", included: true },
      { name: "Customised Theme Cake (1 kg)", included: true },
      { name: "Extended Photography (30 Mins)", included: true },
      { name: "Cold Fire Grand Entry (6 pcs)", included: true },
      { name: "Cinematic Videography (1-Min Reel)", included: true },
      { name: "Atmospheric Hall Fog (4 Pots)", included: true },
    ],
  },
];

export default function PackagesSection() {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(2); // Card 02 (SPECIAL) active by default
  const [expandedId, setExpandedId] = useState(null);

  const toggleExpand = (id, e) => {
    e.stopPropagation();
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="cc-compact-root">
      <Helmet>
        <title>Celebration Combos &amp; Packages | Carnival Castle</title>
        <meta
          name="description"
          content="Choose your private theatre celebration package. Standard, Special, and Premium combo plans with decor, custom cake, fog entry and photography."
        />
      </Helmet>

      <Header />

      <main className="cc-compact-main">
        {/* ── TOP HERO HEADER (COMPACT TYPOGRAPHY) ── */}
        <section className="cc-hero-compact">
          <div className="cc-content-container">
            <div className="cc-kicker-pill">
              <span className="cc-kicker-spark">✦</span>
              <span>PRIVATE THEATRE EXPERIENCES</span>
              <span className="cc-kicker-spark">✦</span>
            </div>

            <h1 className="cc-compact-title">
              Choose Your <span className="cc-compact-gradient">Celebration Combo</span>
            </h1>

            <p className="cc-compact-lead">
              Every package includes a <strong>100% Private Theatre</strong>, ambient decor,
              handcrafted cake &amp; professional photography.
            </p>

            {/* ── ON TOP SELECTING OPTION (INTERACTIVE TIER SWITCHER) ── */}
            <div className="cc-top-selector-wrapper">
              <div className="cc-top-selector-bar">
                {COMBOS.map((combo) => (
                  <button
                    key={combo.id}
                    type="button"
                    className={`cc-selector-pill-btn btn-${combo.themeClass} ${
                      combo.id === activeId ? "is-tab-active" : ""
                    }`}
                    onClick={() => setActiveId(combo.id)}
                  >
                    <span className="cc-pill-num">{combo.tier}</span>
                    <span className="cc-pill-title">{combo.name}</span>
                    {combo.isFeatured && <span className="cc-pill-badge-star">★ POPULAR</span>}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── 3 COMPACT EXPERIENCE CARDS WITH COLOR-SHIFT ANIMATION ── */}
        <section className="cc-cards-compact-sec">
          <div className="cc-content-container">
            <div className="cc-compact-grid">
              {COMBOS.map((combo) => {
                const isActive = combo.id === activeId;
                const isExpanded = expandedId === combo.id;
                const totalInclusions = combo.fullFeatures.filter(
                  (f) => f.included
                ).length;

                return (
                  <article
                    key={combo.id}
                    className={`cc-compact-card ${combo.themeClass} ${
                      isActive ? "is-card-active" : "is-card-idle"
                    }`}
                    onClick={() => setActiveId(combo.id)}
                    role="button"
                    tabIndex={0}
                    aria-pressed={isActive}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setActiveId(combo.id);
                      }
                    }}
                  >
                    {/* Breathing Color Halo Layer */}
                    <div
                      className="cc-color-halo"
                      style={{ background: combo.glowColor }}
                    />

                    {/* Animated Color-Morph Border Ring */}
                    <div className="cc-color-border-glow" />

                    {/* Top Animated Color Bar */}
                    <div className="cc-card-top-color-bar" />

                    {/* Card Surface */}
                    <div className="cc-compact-card-body">
                      {/* Top Header: Tier Indicator + Floating Badge */}
                      <div className="cc-meta-row">
                        <span className="cc-tier-tag">PLAN {combo.tier}</span>

                        <div className={`cc-compact-badge badge-${combo.badgeType}`}>
                          {combo.badgeType === "featured" ? (
                            <Crown size={11} className="cc-crown-ico" />
                          ) : combo.badgeType === "premium" ? (
                            <Sparkles size={10} className="cc-sparkle-ico" />
                          ) : (
                            <span className="cc-star-ico">✦</span>
                          )}
                          <span>{combo.badge}</span>
                        </div>
                      </div>

                      {/* Package Title & Subtitle (Compact font) */}
                      <div className="cc-title-block">
                        <h2 className="cc-plan-name">{combo.name}</h2>
                        <div className="cc-plan-sub">{combo.subtitle}</div>
                        <p className="cc-plan-desc">{combo.tagline}</p>
                      </div>

                      {/* 4 Compact Highlight Chips */}
                      <div className="cc-compact-chips-grid">
                        {combo.highlightChips.map((chip, cIdx) => (
                          <div key={cIdx} className="cc-compact-chip">
                            <span className="cc-chip-icon">{chip.emoji}</span>
                            <span className="cc-chip-lbl">{chip.label}</span>
                          </div>
                        ))}
                      </div>

                      <div className="cc-compact-divider" />

                      {/* Inclusions List */}
                      <div className="cc-inclusions-block">
                        <div className="cc-inclusions-header">
                          <span className="cc-inc-kicker">KEY INCLUSIONS</span>
                          <span className="cc-inc-count-badge">
                            {totalInclusions} Deliverables
                          </span>
                        </div>

                        <ul className="cc-inc-rows-list">
                          {combo.featuresList.map((feat, fIdx) => (
                            <li key={fIdx} className="cc-inc-item">
                              <span className="cc-check-circle">
                                <Check size={9.5} strokeWidth={3.5} />
                              </span>
                              <span className="cc-inc-text-item">{feat}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Accordion Toggle */}
                      <button
                        type="button"
                        className="cc-toggle-details-btn"
                        onClick={(e) => toggleExpand(combo.id, e)}
                        aria-expanded={isExpanded}
                      >
                        <span>
                          {isExpanded
                            ? "Hide Checklist Details"
                            : `+ View All ${totalInclusions} Inclusions Checklist`}
                        </span>
                        <ChevronDown
                          size={12}
                          className={`cc-chevron-flip ${isExpanded ? "open" : ""}`}
                        />
                      </button>

                      {isExpanded && (
                        <div className="cc-drawer-container">
                          <div className="cc-drawer-scroller">
                            {combo.fullFeatures.map((item, idx) => (
                              <div
                                key={idx}
                                className={`cc-drawer-item ${
                                  item.included ? "is-yes" : "is-no"
                                }`}
                              >
                                <span className="cc-drawer-status-ico">
                                  {item.included ? (
                                    <Check size={9} strokeWidth={3.5} />
                                  ) : (
                                    "✕"
                                  )}
                                </span>
                                <span className="cc-drawer-item-title">{item.name}</span>
                                <span className="cc-drawer-state-tag">
                                  {item.included ? "Included" : "Tier Upgrade"}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ── CARD BOTTOM ACTIONS ── */}
                      <div className="cc-card-cta-group">
                        <button
                          type="button"
                          className="cc-compact-book-btn"
                          style={{ background: combo.btnGradient }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/locations");
                          }}
                        >
                          <span className="cc-btn-light-beam" />
                          <span className="cc-btn-inner-row">
                            <span>Book {combo.name} Experience</span>
                            <ArrowRight size={13} className="cc-btn-arr-move" />
                          </span>
                        </button>

                        <a
                          href={
                            "https://wa.me/918374777834?text=" +
                            encodeURIComponent(
                              "Hi Carnival Castle, I would like to reserve or customize " +
                                combo.tierName +
                                " — " +
                                combo.name +
                                " (" +
                                combo.subtitle +
                                ")."
                            )
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cc-compact-wa-btn"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <MessageCircle size={13} className="cc-wa-symbol" />
                          <span>Customise via WhatsApp</span>
                        </a>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* ── COMPACT TYPOGRAPHY & INTERACTIVE COLOR-SHIFT ANIMATION STYLES ── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Playfair+Display:ital,wght@0,600;0,700;0,800;1,400&display=swap');

        /* ── ROOT & COMPACT LAYOUT ── */
        .cc-compact-root {
          background-color: #FAF6F0;
          background-image: 
            radial-gradient(ellipse 70% 30% at 50% 0%, rgba(122, 40, 138, 0.06) 0%, transparent 65%),
            radial-gradient(circle at 92% 16%, rgba(201, 168, 76, 0.08) 0%, transparent 40%),
            radial-gradient(circle at 8% 50%, rgba(122, 40, 138, 0.05) 0%, transparent 45%);
          color: #1A032B;
          min-height: 100vh;
          font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
          position: relative;
          overflow-x: hidden;
          -webkit-font-smoothing: antialiased;
        }

        .cc-compact-root *, .cc-compact-root *::before, .cc-compact-root *::after {
          box-sizing: border-box;
        }

        .cc-content-container {
          max-width: 1140px;
          width: calc(100% - 36px);
          margin: 0 auto;
        }

        @media (max-width: 640px) {
          .cc-content-container {
            width: calc(100% - 22px);
          }
        }

        /* ── HERO HEADER (DECREASED LETTER SIZES) ── */
        .cc-hero-compact {
          text-align: center;
          padding: 32px 16px 16px;
          position: relative;
        }

        .cc-kicker-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 1.8px;
          color: #8C6A18;
          text-transform: uppercase;
          background: #FFFFFF;
          border: 1px solid rgba(201, 168, 76, 0.3);
          padding: 4px 13px;
          border-radius: 100px;
          margin-bottom: 10px;
          box-shadow: 0 2px 10px rgba(201, 168, 76, 0.08);
        }

        .cc-kicker-spark {
          color: #C9A84C;
          font-size: 9px;
        }

        .cc-compact-title {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: clamp(24px, 3.2vw, 36px);
          font-weight: 800;
          line-height: 1.18;
          color: #1A032B;
          max-width: 700px;
          margin: 0 auto 8px;
          letter-spacing: -0.3px;
        }

        .cc-compact-gradient {
          background: linear-gradient(135deg, #5E0E73 0%, #B32671 50%, #C9A84C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          display: inline-block;
        }

        .cc-compact-lead {
          font-size: 13.5px;
          line-height: 1.5;
          color: #584662;
          max-width: 580px;
          margin: 0 auto 16px;
          font-weight: 500;
        }

        .cc-compact-lead strong {
          color: #1A032B;
        }

        /* ── ON TOP SELECTING OPTION (INTERACTIVE COLOR TABS) ── */
        .cc-top-selector-wrapper {
          display: flex;
          justify-content: center;
          margin: 0 auto 6px;
        }

        .cc-top-selector-bar {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 4px;
          background: #FFFFFF;
          border: 1px solid rgba(201, 168, 76, 0.32);
          border-radius: 100px;
          box-shadow: 0 4px 16px rgba(26, 3, 43, 0.05);
        }

        .cc-selector-pill-btn {
          border: none;
          background: transparent;
          padding: 7px 16px;
          border-radius: 100px;
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-size: 11.5px;
          font-weight: 800;
          color: #5D4B68;
          cursor: pointer;
          transition: 
            background 0.35s cubic-bezier(0.16, 1, 0.3, 1),
            color 0.35s cubic-bezier(0.16, 1, 0.3, 1),
            transform 0.2s cubic-bezier(0.16, 1, 0.3, 1),
            box-shadow 0.35s ease;
        }

        .cc-selector-pill-btn:hover {
          color: #1A032B;
          background: rgba(201, 168, 76, 0.08);
        }

        .cc-selector-pill-btn:active {
          transform: scale(0.96);
        }

        /* Color Shifting on Selector Buttons */
        .cc-selector-pill-btn.btn-theme-standard.is-tab-active {
          background: linear-gradient(135deg, #7A5C16 0%, #B38E32 50%, #D4AF37 100%);
          color: #FFFFFF;
          box-shadow: 0 3px 12px rgba(179, 142, 50, 0.35);
        }

        .cc-selector-pill-btn.btn-theme-special.is-tab-active {
          background: linear-gradient(135deg, #2D0A31 0%, #5E0E73 50%, #B32671 100%);
          color: #FFF2D6;
          box-shadow: 0 3px 12px rgba(94, 14, 115, 0.35);
        }

        .cc-selector-pill-btn.btn-theme-premium.is-tab-active {
          background: linear-gradient(135deg, #3B0764 0%, #6B21A8 50%, #9333EA 100%);
          color: #FAF5FF;
          box-shadow: 0 3px 12px rgba(147, 51, 234, 0.35);
        }

        .cc-pill-num {
          font-size: 9.5px;
          opacity: 0.8;
          letter-spacing: 0.5px;
        }

        .cc-pill-badge-star {
          font-size: 9px;
          color: #DFBD69;
          font-weight: 900;
          letter-spacing: 0.3px;
        }

        /* ── CARDS GRID ── */
        .cc-cards-compact-sec {
          padding: 8px 0 46px;
        }

        .cc-compact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 18px;
          align-items: stretch;
          perspective: 1000px;
        }

        /* ── INDIVIDUAL COMPACT CARD WITH COLOR SHIFT ANIMATION ── */
        .cc-compact-card {
          position: relative;
          border-radius: 18px;
          display: flex;
          flex-direction: column;
          cursor: pointer;
          user-select: none;
          outline: none;
          transition: 
            transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
            box-shadow 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }

        /* Color Halo Layer */
        .cc-color-halo {
          position: absolute;
          inset: -6px;
          border-radius: 24px;
          filter: blur(20px);
          opacity: 0;
          pointer-events: none;
          z-index: 0;
          transition: opacity 0.4s ease, background 0.4s ease;
        }

        /* Color-Morph Border Glow Ring */
        .cc-color-border-glow {
          position: absolute;
          inset: 0;
          border-radius: 18px;
          pointer-events: none;
          z-index: 3;
          border: 2px solid transparent;
          transition: border-color 0.35s ease, box-shadow 0.35s ease;
        }

        /* Top Color Accent Line */
        .cc-card-top-color-bar {
          height: 4px;
          width: 100%;
          border-top-left-radius: 18px;
          border-top-right-radius: 18px;
          background: transparent;
          transition: background 0.35s ease;
        }

        /* Card Surface Body */
        .cc-compact-card-body {
          background: #FFFFFF;
          border-radius: 18px;
          border: 1px solid rgba(201, 168, 76, 0.22);
          box-shadow: 0 4px 18px rgba(26, 3, 43, 0.03);
          padding: 20px 18px 18px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          position: relative;
          z-index: 1;
          transition: 
            border-color 0.35s cubic-bezier(0.16, 1, 0.3, 1),
            box-shadow 0.35s cubic-bezier(0.16, 1, 0.3, 1),
            background 0.35s ease;
        }

        /* ── COLOR-SHIFT HOVER & ACTIVE CLICKING STATES ── */
        .cc-compact-card:hover {
          transform: translateY(-6px) scale(1.01);
        }

        .cc-compact-card:active {
          transform: translateY(-3px) scale(0.99);
        }

        /* Theme-Specific Color Transitions on Hover & Active */
        /* STANDARD (Amber/Gold Theme) */
        .cc-compact-card.theme-standard:hover .cc-color-halo {
          opacity: 0.6;
        }
        .cc-compact-card.theme-standard.is-card-active {
          transform: translateY(-5px) scale(1.015);
        }
        .cc-compact-card.theme-standard.is-card-active .cc-compact-card-body {
          border-color: #B38E32;
          box-shadow: 0 16px 36px rgba(179, 142, 50, 0.2), 0 0 0 1px rgba(212, 175, 55, 0.3);
        }
        .cc-compact-card.theme-standard.is-card-active .cc-color-halo {
          opacity: 0.85;
          animation: ccAuraPulseGold 4s infinite alternate ease-in-out;
        }
        .cc-compact-card.theme-standard.is-card-active .cc-card-top-color-bar {
          background: linear-gradient(90deg, #DFBD69, #C9A84C, #B38E32);
        }

        /* SPECIAL (Imperial Purple & Royal Gold Theme) */
        .cc-compact-card.theme-special:hover .cc-color-halo {
          opacity: 0.65;
        }
        .cc-compact-card.theme-special.is-card-active {
          transform: translateY(-5px) scale(1.015);
        }
        .cc-compact-card.theme-special.is-card-active .cc-compact-card-body {
          border-color: #C9A84C;
          border-width: 1.5px;
          box-shadow: 0 18px 40px rgba(94, 14, 115, 0.16), 0 0 0 1px rgba(201, 168, 76, 0.35);
        }
        .cc-compact-card.theme-special.is-card-active .cc-color-halo {
          opacity: 0.9;
          animation: ccAuraPulseSpecial 4s infinite alternate ease-in-out;
        }
        .cc-compact-card.theme-special.is-card-active .cc-card-top-color-bar {
          background: linear-gradient(90deg, #DFBD69 0%, #C9A84C 45%, #7A288A 100%);
        }

        /* PREMIUM (Deluxe Electric Violet Theme) */
        .cc-compact-card.theme-premium:hover .cc-color-halo {
          opacity: 0.6;
        }
        .cc-compact-card.theme-premium.is-card-active {
          transform: translateY(-5px) scale(1.015);
        }
        .cc-compact-card.theme-premium.is-card-active .cc-compact-card-body {
          border-color: #9333EA;
          box-shadow: 0 18px 40px rgba(147, 51, 234, 0.18), 0 0 0 1px rgba(168, 85, 247, 0.35);
        }
        .cc-compact-card.theme-premium.is-card-active .cc-color-halo {
          opacity: 0.85;
          animation: ccAuraPulsePurple 4s infinite alternate ease-in-out;
        }
        .cc-compact-card.theme-premium.is-card-active .cc-card-top-color-bar {
          background: linear-gradient(90deg, #7E22CE 0%, #9333EA 50%, #C084FC 100%);
        }

        @keyframes ccAuraPulseGold {
          0% { transform: scale(0.97); opacity: 0.6; }
          100% { transform: scale(1.03); opacity: 0.9; }
        }
        @keyframes ccAuraPulseSpecial {
          0% { transform: scale(0.97); opacity: 0.65; }
          100% { transform: scale(1.03); opacity: 0.95; }
        }
        @keyframes ccAuraPulsePurple {
          0% { transform: scale(0.97); opacity: 0.6; }
          100% { transform: scale(1.03); opacity: 0.9; }
        }

        .cc-compact-card.is-card-idle {
          opacity: 0.92;
        }
        .cc-compact-card.is-card-idle:hover {
          opacity: 1;
        }

        /* ── CARD TOP META ROW ── */
        .cc-meta-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .cc-tier-tag {
          font-size: 9.5px;
          font-weight: 800;
          letter-spacing: 1px;
          color: #8C6A18;
          background: rgba(201, 168, 76, 0.12);
          padding: 2.5px 7px;
          border-radius: 5px;
        }

        .cc-compact-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 8.5px;
          font-weight: 800;
          letter-spacing: 0.5px;
          padding: 3.5px 8px;
          border-radius: 100px;
          text-transform: uppercase;
        }

        .badge-featured {
          background: linear-gradient(135deg, #DFBD69 0%, #C9A84C 50%, #B38E32 100%);
          color: #1A032B;
          box-shadow: 0 2px 8px rgba(201, 168, 76, 0.35);
          animation: ccCrownBlink 2.4s infinite alternate;
        }

        @keyframes ccCrownBlink {
          0% { transform: scale(1); }
          100% { transform: scale(1.04); }
        }

        .cc-crown-ico {
          color: #1A032B;
        }

        .badge-premium {
          background: linear-gradient(135deg, #2D0A31 0%, #5E0E73 100%);
          color: #FFF0D4;
          border: 1px solid rgba(201, 168, 76, 0.4);
        }

        .cc-sparkle-ico {
          color: #DFBD69;
        }

        .badge-classic {
          background: #FAF6F0;
          color: #8C6A18;
          border: 1px solid rgba(201, 168, 76, 0.25);
        }

        .cc-star-ico {
          color: #C9A84C;
          font-size: 9px;
        }

        /* ── TITLE BLOCK (COMPACTED) ── */
        .cc-title-block {
          margin-bottom: 10px;
        }

        .cc-plan-name {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 20px;
          font-weight: 800;
          color: #1A032B;
          margin: 0 0 2px 0;
          line-height: 1.2;
        }

        .cc-plan-sub {
          font-size: 11px;
          font-weight: 700;
          color: #B38E32;
          margin-bottom: 6px;
          letter-spacing: 0.2px;
        }

        .cc-plan-desc {
          font-size: 11.5px;
          line-height: 1.45;
          color: #584662;
          margin: 0;
          min-height: 32px;
        }

        /* ── COMPACT HIGHLIGHT CHIPS (2x2 GRID) ── */
        .cc-compact-chips-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 5px;
          margin-bottom: 10px;
        }

        .cc-compact-chip {
          background: #FAF6F0;
          border: 1px solid rgba(201, 168, 76, 0.2);
          border-radius: 7px;
          padding: 5px 7px;
          display: flex;
          align-items: center;
          gap: 5px;
          transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
        }

        .cc-compact-chip:hover {
          background: #FFFFFF;
          transform: translateY(-2px);
          border-color: rgba(201, 168, 76, 0.5);
        }

        .cc-chip-icon {
          font-size: 11.5px;
          flex-shrink: 0;
        }

        .cc-chip-lbl {
          font-size: 10px;
          font-weight: 700;
          color: #2D0A31;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Hairline Divider */
        .cc-compact-divider {
          height: 1px;
          background: rgba(201, 168, 76, 0.18);
          margin-bottom: 10px;
        }

        /* ── INCLUSIONS BLOCK (COMPACT TEXT) ── */
        .cc-inclusions-block {
          margin-bottom: 10px;
        }

        .cc-inclusions-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 7px;
        }

        .cc-inc-kicker {
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.8px;
          color: #7A288A;
        }

        .cc-inc-count-badge {
          font-size: 9.5px;
          font-weight: 700;
          color: #8C6A18;
          background: rgba(201, 168, 76, 0.12);
          padding: 1.5px 6px;
          border-radius: 5px;
        }

        .cc-inc-rows-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .cc-inc-item {
          display: flex;
          align-items: flex-start;
          gap: 7px;
          font-size: 11.5px;
          color: #2D0A31;
          line-height: 1.35;
          transition: transform 0.2s ease;
        }

        .cc-inc-item:hover {
          transform: translateX(3px);
        }

        .cc-check-circle {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #10B981;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 1px;
          box-shadow: 0 1px 4px rgba(16, 185, 129, 0.25);
        }

        .cc-inc-text-item {
          font-weight: 600;
        }

        /* ── ACCORDION TOGGLE LINK ── */
        .cc-toggle-details-btn {
          width: 100%;
          background: #FAF6F0;
          border: 1px dashed rgba(122, 40, 138, 0.25);
          border-radius: 8px;
          padding: 6px 10px;
          font-size: 10.5px;
          font-weight: 700;
          color: #7A288A;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          transition: all 0.22s ease;
        }

        .cc-toggle-details-btn:hover {
          background: #F3ECFA;
          border-color: #7A288A;
        }

        .cc-chevron-flip {
          transition: transform 0.25s ease;
        }

        .cc-chevron-flip.open {
          transform: rotate(180deg);
        }

        /* Drawer Box */
        .cc-drawer-container {
          background: #FAF6F0;
          border: 1px solid rgba(201, 168, 76, 0.25);
          border-radius: 10px;
          padding: 8px;
          margin-bottom: 12px;
          animation: ccFadeDownCompact 0.25s ease-out;
        }

        @keyframes ccFadeDownCompact {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .cc-drawer-scroller {
          max-height: 160px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 5px;
          padding-right: 3px;
        }

        .cc-drawer-scroller::-webkit-scrollbar {
          width: 3px;
        }
        .cc-drawer-scroller::-webkit-scrollbar-thumb {
          background: rgba(201, 168, 76, 0.4);
          border-radius: 3px;
        }

        .cc-drawer-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 10.5px;
          padding: 2px 0;
        }

        .cc-drawer-item.is-yes {
          color: #1A032B;
        }

        .cc-drawer-item.is-no {
          color: #9C8FA6;
        }

        .cc-drawer-status-ico {
          width: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-weight: 800;
        }

        .is-yes .cc-drawer-status-ico {
          color: #10B981;
        }

        .is-no .cc-drawer-status-ico {
          color: #A094A8;
          font-size: 8.5px;
        }

        .cc-drawer-item-title {
          flex: 1;
          font-weight: 500;
        }

        .cc-drawer-state-tag {
          font-size: 8.5px;
          font-weight: 700;
          padding: 1.5px 5px;
          border-radius: 4px;
        }

        .is-yes .cc-drawer-state-tag {
          background: rgba(16, 185, 129, 0.12);
          color: #059669;
        }

        .is-no .cc-drawer-state-tag {
          background: rgba(160, 148, 168, 0.12);
          color: #8C7B99;
        }

        /* ── CARD BOTTOM ACTIONS ── */
        .cc-card-cta-group {
          margin-top: auto;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding-top: 6px;
        }

        .cc-compact-book-btn {
          width: 100%;
          border: none;
          color: #FAF4E6;
          padding: 11px 16px;
          border-radius: 11px;
          font-size: 12.5px;
          font-weight: 800;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 14px rgba(26, 3, 43, 0.15);
          transition: 
            transform 0.22s cubic-bezier(0.16, 1, 0.3, 1),
            box-shadow 0.22s cubic-bezier(0.16, 1, 0.3, 1),
            filter 0.22s ease;
        }

        .cc-compact-book-btn:hover {
          transform: translateY(-2px);
          filter: brightness(1.08);
          box-shadow: 0 6px 20px rgba(94, 14, 115, 0.3);
        }

        .cc-compact-book-btn:active {
          transform: scale(0.97);
        }

        .cc-btn-inner-row {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }

        .cc-btn-arr-move {
          transition: transform 0.2s ease;
        }

        .cc-compact-book-btn:hover .cc-btn-arr-move {
          transform: translateX(4px);
        }

        .cc-btn-light-beam {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
          transform: skewX(-20deg);
          animation: ccBeamPulse 3.6s infinite;
          z-index: 1;
        }

        @keyframes ccBeamPulse {
          0%, 65% { left: -70%; }
          100% { left: 140%; }
        }

        .cc-compact-wa-btn {
          width: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          background: #FFFFFF;
          border: 1px solid rgba(37, 211, 102, 0.35);
          color: #128C7E;
          padding: 8.5px 14px;
          border-radius: 11px;
          font-size: 11.5px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .cc-compact-wa-btn:hover {
          background: #F0FDF4;
          border-color: #25D366;
          color: #075E54;
          transform: translateY(-1.5px);
          box-shadow: 0 3px 10px rgba(37, 211, 102, 0.15);
        }

        .cc-wa-symbol {
          color: #25D366;
        }

        /* ── RESPONSIVE DESIGN ── */
        @media (max-width: 980px) {
          .cc-compact-grid {
            gap: 14px;
          }
          .cc-compact-card-body {
            padding: 16px 14px 14px;
          }
          .cc-plan-name {
            font-size: 18px;
          }
        }

        @media (max-width: 820px) {
          .cc-compact-grid {
            grid-template-columns: 1fr;
            max-width: 440px;
            margin: 0 auto;
            gap: 20px;
          }
          .cc-compact-card {
            transform: none !important;
          }
        }
      `}</style>
    </div>
  );
}
